import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { List, Segment } from 'semantic-ui-react';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { uniqueKey } from '../../common/keys';
import { gEnums } from '../../enums/globalEnums';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import { useFcm } from 'global/cnr/contexts/useHelpers/useFcm';
import { PapsContext } from 'global/cnr/contexts/PapsContext';
import { ClientInfoContext } from 'global/cnr/contexts/ClientInfoContext';
import { NavigationContext } from 'global/cnr/contexts/NavigationContext';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares ';

const UserEvents = () => {

  // papsContext
  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}

  // clientInfoContext
  const clientInfoContext = useContext(ClientInfoContext)
  const { clientInfo_state } = clientInfoContext ?? {}
  const { events: events_client } = clientInfo_state ?? {}

  // navigationContext
  const navigationContext = useContext(NavigationContext)
  const { navigation_fns } = navigationContext ?? {}

  // authContext  
  const appUserAccess = useAppUserAccess()
  const { displayName, email, events: events_appUser, clientAccessKey } = appUserAccess ?? {}

  console.log('events_client', events_client)
  console.log('events_appUser', events_appUser)

  // papsContext 
  const { pathViews } = paps_state ?? {}
  const { events: eventKey } = pathViews ?? {}

  const { sendFcm_errorTopic } = useFcm()

  let noEventsCaption = !pathViews?.clients ? 'You do not have any events. The Client is unknown.' : 'You do not have any events.'
  if (!events_appUser) { noEventsCaption = 'Searching App User Events' }

  const [allowedEvents, setAllowedEvents] = useState({})

  useEffect(() => {
    const _allowedEvents = {}
    if (events_client && events_appUser) {
      const _clientEvents = events_client //_.filter(events_client, { eventStatusType: gEnums.eventStatusTypes.active })
      _.forEach(_clientEvents, (clientEvent) => {
        const { _itemKey } = clientEvent
        if (events_appUser[_itemKey]) {
          _allowedEvents[_itemKey] = clientEvent
        }
      })
    }
    setAllowedEvents(_allowedEvents)
    if (!events_appUser) {
      sendFcm_errorTopic('App User Event Error', `The appUser '${displayName || email}' does not have the event '${pathViews?.events}' associated with them.`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [events_client, events_appUser]);

  const handleGoToEvent = (e, key) => {
    // clickedItem, itemKey, modifyMode, opts
    if (clientAccessKey) {
      const opts = { directPath: '/clients/' + clientAccessKey + '/events/' + key }
      if (eventKey !== key) {
        navigation_fns.handleNav_item({ key: 'events' }, key, null, opts)
      }
    } else {
      if (eventKey !== key) {
        navigation_fns.handleNav_item({ key: 'events' }, key)
      }
    }
  }

  const eventList = () => {
    const lis = []
    if (allowedEvents && Object.keys(allowedEvents).length > 0) {
      console.log('allowedEvents', allowedEvents)
      const handleClick = (item, itemKey) => {
        console.log('item', item, itemKey)
        handleGoToEvent(null, item?._itemKey)
      }
      return <ItemMenuSquares menuItems={allowedEvents} imsType={_imsTypes.event} iconItem={'calendar outline'} icon={'cog'} onClick={handleClick} />
      _.forEach(allowedEvents, (event, key) => {
        let { name } = event
        if (!name && events_client && events_client[key]) {
          name = events_client[key].name
        }
        lis.push(
          <List.Item key={uniqueKey('ue', 'li', key)} onClick={(e) => { handleGoToEvent(e, key) }}>
            <List.Icon name='calendar check outline' size='large' verticalAlign='middle' color={eventKey === key ? 'green' : 'grey'} />
            <List.Content>
              <List.Header >{name ? name : key}</List.Header>
              <List.Description as='a'>{event.startDate}</List.Description>
            </List.Content>
          </List.Item>
        )
      })
      return <div key={uniqueKey('ue', 'd')} className={'c-container'} >
        <div className={'c-content'} >
          < List divided relaxed >
            {lis}
          </List ></div>
      </div>
    } else {
      return <div key={uniqueKey('ue', 'd')} className={'c-container'} >
        <div className={'c-content padd'}>{noEventsCaption}</div></div>
    }
  }

  const header = () => displayName ? 'Active Events for ' + displayName : 'Events'

  return <Wrapper
    header={!eventKey && header()}
    content={<Segment basic>{eventList()}</Segment>}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode' }}
  />

}

export default UserEvents